/* ============================================================
   Golfstore: mobiele aanpassingen die niet met CSS alleen kunnen
   Bestand: assets/golfstore-mobile.js
   Laden in layout/theme.liquid, na theme.js:
     <script src="{{ 'golfstore-mobile.js' | asset_url }}" defer></script>

   Wat het doet
   ------------
   Het blok "Waar het advies op is gebaseerd" in de Clubadvies-sectie
   bestaat uit vier tekstkaarten. Op een telefoon kost dat bijna 300px
   voordat je bij de producten bent. Dit script maakt er een uitklapper
   van die op mobiel dicht staat en op desktop open. De tekst blijft
   dus gewoon in de pagina staan, ook voor zoekmachines.

   Zonder JavaScript verandert er niets: de kaarten staan dan open,
   precies zoals het thema ze zelf rendert.
   ============================================================ */

(function () {
  'use strict';

  var MOBIEL = '(max-width: 740px)';
  var STANDAARD_KOP = 'Waar het advies op is gebaseerd';

  /* Opmaak van de uitklapper. Staat hier en niet in golfstore-mobile.css,
     omdat dit script het element zelf maakt: opmaak en markup horen bij
     elkaar. Op desktop ziet niemand er iets van; daar blijft het een kop
     met de kaarten eronder. */
  function stijlToevoegen() {
    if (document.getElementById('gs-mobile-styles')) return;
    var stijl = document.createElement('style');
    stijl.id = 'gs-mobile-styles';
    stijl.textContent = [
      '.ca__stories-box > summary.ca__stories-summary{',
      '  list-style:none;display:flex;align-items:center;',
      '  justify-content:space-between;gap:12px;}',
      '.ca__stories-box > summary::-webkit-details-marker{display:none;}',
      '.ca__stories-summary .ca__stories-heading{margin:0;}',
      '.ca__stories-chevron{display:none;flex:0 0 auto;transition:rotate .2s ease;}',
      '@media screen and (min-width:741px){',
      '  .ca__stories-summary{pointer-events:none;}}',
      '@media screen and (max-width:740px){',
      '  .ca__stories-summary{cursor:pointer;padding:12px 0;',
      '    border-top:1px solid rgba(0,0,0,.12);',
      '    border-bottom:1px solid rgba(0,0,0,.12);}',
      '  .ca__stories-chevron{display:inline-flex;}',
      '  .ca__stories-box[open] .ca__stories-summary{border-bottom-color:transparent;}',
      '  .ca__stories-box[open] .ca__stories-chevron{rotate:180deg;}}'
    ].join('\n');
    document.head.appendChild(stijl);
  }

  /* Zet de bestaande inhoud van .ca__stories in een details/summary.
     De bestaande kop verhuist naar de summary, zodat er niet ineens twee
     koppen staan. */
  function uitklapperMaken(stories) {
    if (stories.gsDetails) return stories.gsDetails;

    var details = document.createElement('details');
    details.className = 'ca__stories-box';

    var summary = document.createElement('summary');
    summary.className = 'ca__stories-summary';

    var kop = stories.querySelector('.ca__stories-heading');
    if (!kop) {
      kop = document.createElement('h3');
      kop.className = 'ca__stories-heading';
      kop.textContent = STANDAARD_KOP;
    }
    summary.appendChild(kop);

    var chevron = document.createElement('span');
    chevron.className = 'ca__stories-chevron';
    chevron.setAttribute('aria-hidden', 'true');
    chevron.innerHTML =
      '<svg viewBox="0 0 24 24" width="18" height="18">' +
      '<path d="m6 9 6 6 6-6" fill="none" stroke="currentColor" stroke-width="2"' +
      ' stroke-linecap="round" stroke-linejoin="round"/></svg>';
    summary.appendChild(chevron);

    details.appendChild(summary);
    while (stories.firstChild) {
      details.appendChild(stories.firstChild);
    }
    stories.appendChild(details);

    stories.gsDetails = details;
    return details;
  }

  function start() {
    var blokken = document.querySelectorAll('.gs-clubadvies .ca__stories');
    if (!blokken.length) return;

    stijlToevoegen();

    var mq = window.matchMedia(MOBIEL);

    Array.prototype.forEach.call(blokken, function (stories) {
      var details = uitklapperMaken(stories);
      var zelfGeopend = false;

      /* Heeft de bezoeker zelf geklikt, dan bepaalt hij het verder. */
      details.addEventListener('toggle', function () {
        zelfGeopend = true;
      });

      var afstemmen = function () {
        if (zelfGeopend) return;
        details.open = !mq.matches;
      };

      afstemmen();

      if (mq.addEventListener) {
        mq.addEventListener('change', afstemmen);
      } else if (mq.addListener) {
        mq.addListener(afstemmen);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
